import { inject, Injectable } from '@angular/core';
import { UserService } from '@app/user';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { of } from 'rxjs';
import { navItemsAccessFilter } from '../../utils';
import { NavMenuItem } from '../models/nav-menu-item';

@Injectable({
    providedIn: 'root',
})
export class SettingsNavItemsService {
    private readonly userService = inject(UserService);

    readonly settingsItems$ = of<NavMenuItem[]>([
        {
            name: marker('v3-header-menu-item-my-settings'),
            icon: 'my-settings',
            route: ['/settings'],
            access: () => true,
        },
        {
            name: marker('v3-header-menu-item-logout'),
            icon: 'logout',
            route: [],
            access: () => true,
        },
    ]).pipe(navItemsAccessFilter(this.userService));
}
